@if (error()) {
  <!-- <div class="mb-4 rounded-lg border border-red-200 bg-red-50 p-4 text-sm text-red-700">
    {{ error() }}
  </div> -->
  <app-error-data [title]="error()!" />
}

@if (!error()) {
  <app-attribute-form
    [existingKeys]="existingTitleEnList()"
    [editData]="editAttrFormData()"
    (onAdd)="addAttributeKey($event)"
    (onEdit)="saveEditedAttr($event)"
    (onCancelEdit)="editAttrIndex.set(null)"
    (onImportClick)="showImportModal.set(true)"
    [productType]="productType()" />

  <div class="relative mt-6">
    @if (attributesLoading()) {
      <div class="absolute inset-0 z-10 flex items-center justify-center bg-white/50 backdrop-blur-sm">
        <div class="borderPrimaryColor h-8 w-8 animate-spin rounded-full border-4 border-t-transparent"></div>
      </div>
    }
    <app-attributes-table
      [attributes]="attributesList()"
      (onDrop)="handleReorder($event)"
      (onAddValue)="openValueModal($event)"
      (onEditValue)="editAttributeValue($event.attrIdx, $event.valIdx)"
      (onDeleteValue)="requestDeleteValue($event.attrIdx, $event.valIdx)"
      (onRemove)="requestDeleteAttr($event)"
      (onEditAttr)="openEditAttr($event)" />
  </div>

  @if (showMinAttrError()) {
    <span class="mt-2 block text-sm font-medium text-red-500" i18n="@@attr.validation.minOneAttr">
      Please add at least one attribute before proceeding
    </span>
  }

  <div class="mt-8 flex justify-between border-t border-gray-100 bg-white pt-8">
    @if (productType() !== "edit") {
      <button
        (click)="onBack.emit()"
        [disabled]="loading()"
        class="cursor-pointer rounded-xl border border-gray-300 px-10 py-3 font-bold text-gray-500 transition-all hover:bg-gray-50 disabled:opacity-50"
        i18n="@@product.button.back">
        Back
      </button>
    }

    <div class="flex w-full gap-4 rtl:flex-row-reverse" [ngClass]="isArabic() ? 'mr-auto' : 'ml-auto'">
      @if (productType() !== "edit") {
        <button
          (click)="skipStep()"
          [disabled]="loading()"
          class="cursor-pointer rounded-xl border border-dashed border-gray-300 px-8 py-3 font-bold text-gray-400 transition-all hover:border-gray-400 disabled:opacity-50"
          i18n="@@attr.button.skip">
          Skip
        </button>
      }

      @if (hasUnsavedChanges()) {
        <button
          (click)="saveNewChanges()"
          [disabled]="loading() || !canSaveNewChanges()"
          class="flex cursor-pointer items-center"
          [ngClass]="
            productType() === 'edit'
              ? 'primaryColorBg mr-auto block rounded-[6px] px-5 py-1.5 text-base text-[13px] font-[500] font-medium text-white hover:cursor-pointer'
              : 'rounded-xl bg-gray-800 px-10 py-3 font-bold text-white shadow-lg transition-all hover:bg-gray-900 disabled:opacity-50'
          "
          i18n="@@attr.button.saveEdit">
          @if (loading()) {
            <svg class="me-2 h-4 w-4 animate-spin" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
            </svg>
          }
          Save Changes
        </button>
      }

      @if (productType() !== "edit") {
        <button
          (click)="proceedToNext()"
          [disabled]="loading() || !canProceed()"
          class="bgPrimaryColor hover:bgHoverPrimaryColor flex cursor-pointer items-center rounded-xl px-12 py-3 font-bold text-white shadow-lg transition-all disabled:opacity-50"
          i18n="@@attr.button.next">
          @if (loading()) {
            <svg class="me-2 h-4 w-4 animate-spin" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
            </svg>
          }
          Next
        </button>
      }
    </div>
  </div>
}

<app-add-new-value
  #valueModal
  [hidden]="!showValueModal()"
  [existingValues]="currentAttrValues()"
  [editData]="editData()"
  (onSave)="handleSaveValue($event)"
  (onClose)="closeModal()" />

@if (showImportModal()) {
  <app-import-global-modal
    [globalAttributes]="globalAttributes()"
    [existingKeys]="existingTitleEnList()"
    (onClose)="showImportModal.set(false)"
    (onConfirm)="confirmImport($event)" />
}

@if (deleteConfig()) {
  <app-confirm-delete-modal
    [itemName]="deleteConfig()!.name"
    (onConfirm)="confirmDelete()"
    (onCancel)="deleteConfig.set(null)" />
}
